/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import {
  Container,
  Row,
  Col,
  FormControl,
  InputGroup,
  Button,
} from "react-bootstrap";

import { Icon } from "components";

import "./styles.css";

const Header = (props) => {
  const {
    title,
    subTitle,
    iconName,
    redirectNew,
    flActionBar,
    handleSearch,
    canCreate,
  } = props;
  const [value, setValue] = useState();

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        handleSearch(value);
      }
    };

    document.addEventListener("keydown", listener);

    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [value]);

  return (
    <Container fluid className="mt-2">
      <Row>
        <Col
          md="1"
          className="pl-0 d-flex align-items-center justify-content-between"
        >
          <Icon
            className="material-icons"
            name="keyboard_arrow_left"
            style={{ fontSize: 36 }}
          />

          <Icon
            className="material-icons"
            name={iconName}
            style={{ fontSize: 36 }}
          />
        </Col>

        <Col md="7">
          <h1 className="title">{title}</h1>
          <h1 className="sub-title">{subTitle}</h1>
        </Col>

        <Col
          md="4"
          className="d-flex justify-content-between align-items-center pr-0"
        >
          {flActionBar && (
            <>
              <InputGroup>
                <FormControl
                  type="text"
                  name="quick_filter"
                  placeholder="Pesquisar"
                  onChange={(event) => {
                    setValue(event.target.value);
                  }}
                />
                <InputGroup.Prepend>
                  <Button
                    size="sm"
                    variant="light"
                    onClick={() => handleSearch(value)}
                  >
                    <Icon name="search" />
                  </Button>
                </InputGroup.Prepend>
              </InputGroup>

              {/* <Button size="sm" className="ml-2" variant="outline-dark">
                <Icon name="filter_list" />
              </Button> */}

              {canCreate && (
                <Button size="sm" className="ml-2" href={redirectNew}>
                  <Icon name="add" />
                </Button>
              )}
            </>
          )}
        </Col>
      </Row>
      <Row>
        <Col md="12" className="px-0">
          <hr />
        </Col>
      </Row>
    </Container>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  iconName: PropTypes.string,
  redirectNew: PropTypes.string,
  flActionBar: PropTypes.bool,
  handleSearch: PropTypes.func,
  canCreate: PropTypes.bool,
};
export default Header;
